import { render, staticRenderFns } from "./StorageTable.vue?vue&type=template&id=52c1372c&scoped=true&"
import script from "./StorageTable.vue?vue&type=script&lang=js&"
export * from "./StorageTable.vue?vue&type=script&lang=js&"
import style0 from "./StorageTable.vue?vue&type=style&index=0&id=52c1372c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1372c",
  null
  
)

export default component.exports